import { isFunction, transform } from 'lodash';
import warning from 'warning';
import { findSectionForIndex, normalizeIndex } from '../shared';

const isSectionItemLoaded = (section, index) => {
  let result = false;

  if (index <= section.endIndex) {
    //dont calculate for index exceeding the last one owned by this section
    if (section.bufferStartIndex && index >= section.bufferStartIndex) {
      result = true; //for buffer placeholders simply return true!
    } else {
      const isFn = isFunction(section.isItemLoaded);

      if (isFn) {
        const relIndex = normalizeIndex(index, section);
        result = section.isItemLoaded(relIndex);
      } else {
        result = section.isItemLoaded;
      }
    }
  }

  return !!result; //force boolean
};

const getPagedIds = (sections, start, end) => {
  return transform(
    sections,
    (res, section) => {
      const { id, startIndex, bufferStartIndex, endIndex } = section;

      const sectionEnd = bufferStartIndex ? bufferStartIndex - 1 : endIndex;
      const isStartIndexInSection = start <= end && start >= startIndex && start <= sectionEnd;

      if (isStartIndexInSection) {
        res[id] = [normalizeIndex(start, section), normalizeIndex(Math.min(end, sectionEnd), section)];
        start = endIndex + 1;
      }
    },
    {}
  );
};

const loadMoreItemsFromSections = (sections, start, end) => {
  let result;

  if (sections.length && end) {
    const pages = getPagedIds(sections, start, end);

    result = Promise.all(
      Object.keys(pages).map((id) => {
        const indexes = pages[id],
          section = sections.find((s) => s.id === id);

        return section ? section.loadMore(indexes[0], indexes[1]) : null;
      })
    );
  } else {
    warning(false, '[InfiniteLayout]: loadMoreItems failed because no sections found');
  }

  return result || Promise.resolve();
};

const isItemLoaded = (index, sections) => {
  let result = false;

  if (sections.length) {
    const section = findSectionForIndex(sections, index);

    if (section) {
      result = isSectionItemLoaded(section, index);
    }
  } else {
    warning(false, '[react-window-layout.infiniteLayout]: isItemLoaded failed because no sections found');
  }

  return result;
};

const calculateIndexesForInfiniteGrid = (gridData, useOverscanForLoading) => {
  const { visibleRowStartIndex, visibleRowStopIndex, visibleColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, overscanColumnStopIndex } =
    gridData;

  const endCol = (useOverscanForLoading ? overscanColumnStopIndex : visibleColumnStopIndex) + 1;

  const startRow = useOverscanForLoading ? overscanRowStartIndex : visibleRowStartIndex;
  const endRow = useOverscanForLoading ? overscanRowStopIndex : visibleRowStopIndex;

  return {
    visibleStartIndex: startRow * endCol,
    visibleStopIndex: endRow * endCol,
  };
};

export { getPagedIds, loadMoreItemsFromSections, isItemLoaded, calculateIndexesForInfiniteGrid };
